export const onKeyDown = e => {
  if (e.target.type !== 'textarea' && e.key === 'Enter') {
    // disable submit form on enter
    e.preventDefault();
  }
};
